module.exports = __webpack_public_path__ + "static/meta-2c59ed245e9867b87fd4408450f805f2.gif";